import React from 'react'

import {MainRoutes, RouteName} from './routing/router'

export const subPageDynamicImportMap: Record<keyof MainRoutes, () => Promise<{default: React.FC}>> =
  {
    [RouteName.STOCK]: () =>
      import('./app/page-stock/PageStock').then((module) => ({default: module.PageStock})),
    [RouteName.ELECTRICITY_FORECAST]: () =>
      import('./app/page-electricity/PageElectricityForecast').then((module) => ({
        default: module.PageElectricityForecast
      })),
    [RouteName.SALES_FORECAST]: () =>
      import('@features/sales-forecast').then((module) => ({default: module.PageSalesForecast})),
    [RouteName.PRODUCTION_PLANNING]: () =>
      import('@features/production-planning').then((module) => ({
        default: module.PageProductionPlanning
      })),
    [RouteName.OPTIMIZER]: () =>
      import('./app/page-optimizer/PageOptimizer').then((module) => ({
        default: module.PageOptimizer
      })),
    [RouteName.OPERATOR_VIEW]: () =>
      import('./app/page-operator-view/PageOperatorView').then((module) => ({
        default: module.PageOperatorView
      }))
  }

export const PageNotFound = React.lazy(() =>
  import('./app/page-not-found/PageNotFound').then((module) => ({
    default: module.PageNotFound
  }))
)
